/* ============================================================
   MORIAI — Naturellement Sain
   Shopify OS 2.0 JavaScript (vanilla, no GSAP dependency)
   ============================================================ */

(function() {
  'use strict';

  function initReveal() {
    const obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('moriai-rv--on');
          e.target.querySelectorAll('[data-moriai-count]').forEach(initCounter);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.moriai-rv').forEach(function(el) { obs.observe(el); });
  }

  function initCounter(el) {
    if (el.dataset.done) return;
    el.dataset.done = '1';
    var target = parseInt(el.dataset.moriaiCount, 10);
    var suffix = el.dataset.moriaiSuffix || '';
    var dur = 2200;
    var start = performance.now();
    function step(now) {
      var t = Math.min((now - start) / dur, 1);
      var ease = 1 - Math.pow(1 - t, 3);
      var v = Math.round(ease * target);
      if (target >= 1000000) el.textContent = (v / 1000000).toFixed(1) + 'M' + suffix;
      else if (target >= 1000) el.textContent = (v / 1000).toFixed(0) + 'k' + suffix;
      else el.textContent = v.toLocaleString('fr-CA') + suffix;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initScrollBar() {
    var bar = document.getElementById('moriai-progress-bar');
    if (!bar) return;
    window.addEventListener('scroll', function() {
      var st = window.scrollY;
      var dh = document.body.scrollHeight - window.innerHeight;
      bar.style.width = (st / dh * 100) + '%';
    }, { passive: true });
  }

  function initFloatingCTA() {
    var fcta = document.querySelector('.moriai-fcta');
    if (!fcta) return;
    window.addEventListener('scroll', function() {
      fcta.classList.toggle('moriai-fcta--visible', window.scrollY > 600);
    }, { passive: true });
    var btn = fcta.querySelector('[data-moriai-scroll-to]');
    if (btn) {
      btn.addEventListener('click', function() {
        var target = document.querySelector(btn.dataset.moriaiScrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }

  function initFAQ() {
    document.querySelectorAll('.moriai-faq-item__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.moriai-faq-item');
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.moriai-faq-item__btn').forEach(function(b) {
          b.setAttribute('aria-expanded', 'false');
          b.closest('.moriai-faq-item').classList.remove('moriai-faq-item--open');
        });
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          item.classList.add('moriai-faq-item--open');
        }
      });
    });
  }

  function initCountdown() {
    var h = document.getElementById('moriai-cd-h');
    var m = document.getElementById('moriai-cd-m');
    var s = document.getElementById('moriai-cd-s');
    if (!h || !m || !s) return;
    var hv = 14, mv = 23, sv = 8;
    setInterval(function() {
      if (--sv < 0) { sv = 59; if (--mv < 0) { mv = 59; if (--hv < 0) { hv = 23; } } }
      h.textContent = String(hv).padStart(2, '0');
      m.textContent = String(mv).padStart(2, '0');
      s.textContent = String(sv).padStart(2, '0');
    }, 1000);
  }

  function initTilt() {
    document.querySelectorAll('[data-moriai-tilt]').forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) / (r.width / 2) * 8;
        var y = (e.clientY - r.top - r.height / 2) / (r.height / 2) * -8;
        card.style.transform = 'perspective(700px) rotateX(' + y + 'deg) rotateY(' + x + 'deg)';
      });
      card.addEventListener('mouseleave', function() { card.style.transform = ''; });
    });
  }

  function initSmoothScroll() {
    document.querySelectorAll('[data-moriai-scroll-to]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(el.dataset.moriaiScrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  function initStockBars() {
    setTimeout(function() {
      document.querySelectorAll('.moriai-offer-card__stock-fill').forEach(function(f) {
        var w = f.dataset.moriaiStock || '0';
        f.style.width = w + '%';
      });
    }, 600);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initReveal();
    initScrollBar();
    initFloatingCTA();
    initFAQ();
    initCountdown();
    initTilt();
    initSmoothScroll();
    initStockBars();
  });

})();
